import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
const resources = {
  en: {
    translation: {
      hero: {
        title: 'Humanoid Robotics',
        subtitle: 'With Precision Touch Control',
        description:
          'Revolutionary software enabling remote control of humanoid robots with advanced pressure sensors for safe, delicate interactions with people and objects.',
        cta: 'Get Started',
        learnMore: 'Learn More',
      },
      features: {
        title: 'Advanced Features',
        pressure: {
          title: 'Pressure Sensing',
          description:
            'Real-time feedback from finger pressure sensors ensures gentle, controlled interactions',
        },
        remote: {
          title: 'Remote Control',
          description:
            'Operate humanoid robots from anywhere with VR headset hand recognition for immersive, intuitive control',
        },
        safety: {
          title: 'Safety First',
          description:
            'Designed for delicate tasks with elderly care and sensitive materials',
        },
      },
      useCases: {
        title: 'Use Cases',
        elderly: {
          title: 'Elderly Care',
          description:
            'Assist elderly individuals with precise, gentle touch and support',
        },
        plants: {
          title: 'Plant Handling',
          description: 'Handle delicate plants and materials without damage',
        },
      },
      contact: {
        title: 'Ready to Transform Robotics?',
        description: 'Contact us to learn more about our innovative solution',
        button: 'Contact Us',
      },
    },
  },
  es: {
    translation: {
      hero: {
        title: 'Robótica Humanoide',
        subtitle: 'Con Control Táctil de Precisión',
        description:
          'Software revolucionario que permite el control remoto de robots humanoides con sensores de presión avanzados para interacciones seguras y delicadas con personas y objetos.',
        cta: 'Comenzar',
        learnMore: 'Saber Más',
      },
      features: {
        title: 'Características Avanzadas',
        pressure: {
          title: 'Sensores de Presión',
          description:
            'Retroalimentación en tiempo real de sensores de presión en los dedos garantiza interacciones suaves y controladas',
        },
        remote: {
          title: 'Control Remoto',
          description:
            'Opera robots humanoides desde cualquier lugar con reconocimiento de manos por casco VR para control inmersivo e intuitivo',
        },
        safety: {
          title: 'Seguridad Primero',
          description:
            'Diseñado para tareas delicadas con cuidado de ancianos y materiales sensibles',
        },
      },
      useCases: {
        title: 'Casos de Uso',
        elderly: {
          title: 'Cuidado de Ancianos',
          description: 'Asiste a personas mayores con tacto preciso y gentil',
        },
        plants: {
          title: 'Manejo de Plantas',
          description: 'Maneja plantas y materiales delicados sin daños',
        },
      },
      contact: {
        title: '¿Listo para Transformar la Robótica?',
        description:
          'Contáctanos para conocer más sobre nuestra solución innovadora',
        button: 'Contáctanos',
      },
    },
  },
  fr: {
    translation: {
      hero: {
        title: 'Robotique Humanoïde',
        subtitle: 'Avec Contrôle Tactile de Précision',
        description:
          'Logiciel révolutionnaire permettant le contrôle à distance de robots humanoïdes avec capteurs de pression avancés pour des interactions sûres et délicates avec les personnes et les objets.',
        cta: 'Commencer',
        learnMore: 'En Savoir Plus',
      },
      features: {
        title: 'Fonctionnalités Avancées',
        pressure: {
          title: 'Capteurs de Pression',
          description:
            'Retour en temps réel des capteurs de pression des doigts garantit des interactions douces et contrôlées',
        },
        remote: {
          title: 'Contrôle à Distance',
          description:
            "Opérez des robots humanoïdes de n'importe où avec reconnaissance des mains par casque VR pour un contrôle immersif et intuitif",
        },
        safety: {
          title: "Sécurité d'Abord",
          description:
            'Conçu pour les tâches délicates avec soins aux personnes âgées et matériaux sensibles',
        },
      },
      useCases: {
        title: "Cas d'Usage",
        elderly: {
          title: 'Soins aux Personnes Âgées',
          description:
            'Assistez les personnes âgées avec un toucher précis et doux',
        },
        plants: {
          title: 'Manipulation de Plantes',
          description:
            'Manipulez des plantes et matériaux délicats sans dommages',
        },
      },
      contact: {
        title: 'Prêt à Transformer la Robotique?',
        description:
          'Contactez-nous pour en savoir plus sur notre solution innovante',
        button: 'Nous Contacter',
      },
    },
  },
  ca: {
    translation: {
      hero: {
        title: 'Robòtica Humanoide',
        subtitle: 'Amb Control Tàctil de Precisió',
        description:
          'Programari revolucionari que permet el control remot de robots humanoides amb sensors de pressió avançats per a interaccions segures i delicades amb persones i objectes.',
        cta: 'Començar',
        learnMore: 'Saber Més',
      },
      features: {
        title: 'Característiques Avançades',
        pressure: {
          title: 'Sensors de Pressió',
          description:
            'Retroalimentació en temps real dels sensors de pressió dels dits garanteix interaccions suaus i controlades',
        },
        remote: {
          title: 'Control Remot',
          description:
            'Opera robots humanoides des de qualsevol lloc amb reconeixement de mans per casc VR per a control immersiu i intuïtiu',
        },
        safety: {
          title: 'Seguretat Primer',
          description:
            'Dissenyat per a tasques delicades amb cura de gent gran i materials sensibles',
        },
      },
      useCases: {
        title: "Casos d'Ús",
        elderly: {
          title: 'Cura de Gent Gran',
          description: 'Assisteix persones grans amb tacte precís i gentil',
        },
        plants: {
          title: 'Manipulació de Plantes',
          description: 'Manipula plantes i materials delicats sense danys',
        },
      },
      contact: {
        title: 'Preparat per Transformar la Robòtica?',
        description:
          'Contacta amb nosaltres per conèixer més sobre la nostra solució innovadora',
        button: 'Contacta',
      },
    },
  },
}
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  })
export default i18n
